"use client";

import { c as _c } from "react/compiler-runtime";
import NumberFlow from "@number-flow/react";
import { EM_DASH, getBoundedNumber, getNumberFormatOptions, getNumberPrefix, isValidNumber, ONE_BIL } from "@opensea/i18n";
import { bn } from "@opensea/utils";
import { useLocale } from "../../hooks";
import { classNames } from "../../utils";
export function AnimatedNumber(t0) {
  const $ = _c(31);
  let bounded;
  let className;
  let compactionThreshold;
  let prefix;
  let rest;
  let suffix;
  let t1;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      className,
      display: t1,
      prefix,
      suffix,
      bounded,
      compactionThreshold,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = bounded;
    $[2] = className;
    $[3] = compactionThreshold;
    $[4] = prefix;
    $[5] = rest;
    $[6] = suffix;
    $[7] = t1;
    $[8] = value;
  } else {
    bounded = $[1];
    className = $[2];
    compactionThreshold = $[3];
    prefix = $[4];
    rest = $[5];
    suffix = $[6];
    t1 = $[7];
    value = $[8];
  }
  const display = t1 === undefined ? "quantity" : t1;
  const locale = useLocale();
  if (!isValidNumber(value)) {
    return EM_DASH;
  }
  let boundedNumber;
  let combinedPrefix;
  let numberFormatOptions;
  let t2;
  if ($[9] !== bounded || $[10] !== compactionThreshold || $[11] !== display || $[12] !== prefix || $[13] !== value) {
    const number = bn(value).toNumber();
    numberFormatOptions = getNumberFormatOptions({
      display,
      value: number,
      compactionThreshold
    });
    const lowerBound = numberFormatOptions.maximumFractionDigits !== undefined ? bn(1, numberFormatOptions.maximumFractionDigits).toNumber() : undefined;
    boundedNumber = getBoundedNumber(display, number, {
      upperBound: bounded ? ONE_BIL : undefined,
      lowerBound
    });
    const numberPrefix = getNumberPrefix(display, number, {
      upperBound: bounded ? ONE_BIL : undefined,
      lowerBound
    });
    combinedPrefix = `${prefix || ""}${numberPrefix || ""}`;
    t2 = boundedNumber.toString();
    $[9] = bounded;
    $[10] = compactionThreshold;
    $[11] = display;
    $[12] = prefix;
    $[13] = value;
    $[14] = boundedNumber;
    $[15] = combinedPrefix;
    $[16] = numberFormatOptions;
    $[17] = t2;
  } else {
    boundedNumber = $[14];
    combinedPrefix = $[15];
    numberFormatOptions = $[16];
    t2 = $[17];
  }
  let t3;
  if ($[18] !== className) {
    t3 = classNames("font-mono", className);
    $[18] = className;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  const t4 = combinedPrefix || undefined;
  const t5 = suffix ? ` ${suffix}` : undefined;
  let t6;
  if ($[20] !== boundedNumber || $[21] !== locale || $[22] !== numberFormatOptions || $[23] !== t4 || $[24] !== t5) {
    t6 = <NumberFlow format={numberFormatOptions} locales={locale} prefix={t4} suffix={t5} value={boundedNumber} />;
    $[20] = boundedNumber;
    $[21] = locale;
    $[22] = numberFormatOptions;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== rest || $[27] !== t2 || $[28] !== t3 || $[29] !== t6) {
    t7 = <span aria-label={t2} className={t3} {...rest}>{t6}</span>;
    $[26] = rest;
    $[27] = t2;
    $[28] = t3;
    $[29] = t6;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  return t7;
}